import { off, on, once } from './events';
import {
  DAJI_MSG_SOURCE,
  DAJI_MSG_VERSION,
  getAllowedOrigins,
  isBridgeActive,
  sendToOpenWindow,
  sendToWidgetIframe,
} from './launcher/bridge';
import { getLauncherElement, mountLauncher, setUnreadCount, toggleWidget, unmountLauncher } from './launcher/launcher';
import {
  closeWidget,
  getWidgetIframe,
  hideEndBanner,
  isWidgetOpen,
  openWidget,
  showEndBanner,
} from './launcher/widget';
import {
  boot,
  buildChatUrl,
  buildSessionUrl,
  getConfig,
  isReadyNow,
  open,
  openSafe,
  ready,
  reset,
  update,
  version,
} from './open';
import { sendCard, sendCouponCard, sendOrderCard, sendProductCard } from './send-card';

/**
 * 语法糖：向 widget iframe 下发新身份（典型：宿主 token 续期后）。
 * 底层等价于 sendToWidgetIframe('daji:identity', payload)。
 * widget 未挂载或 iframe 未就绪时返回 false。
 *
 * 扩展：同时携带 tenant/domain 时，App.vue 的 handleIdentity 会同步更新
 * 租户配置到 localStorage，用于 x-tenant-code 请求头。
 */
export function refreshIdentity(payload: {
  token?: string;
  language?: string;
  userId?: string | number;
  supplierId?: string | number;
  /** 新租户标识，随身份刷新同步更新。App 侧写入 localStorage */
  tenant?: string;
  /** 域名标识，与 tenant 同步更新 */
  domain?: string;
  /** 额外请求头，访客页 axios 拦截器会消费（写入 localStorage `daji_extra_headers`） */
  headers?: Record<string, string>;
  /** 额外业务参数，访客页消费（写入 localStorage `daji_extra`） */
  extra?: Record<string, string>;
}): boolean {
  return sendToWidgetIframe('daji:identity', payload);
}

export {
  boot,
  update,
  getConfig,
  open,
  openSafe,
  reset,
  ready,
  isReadyNow,
  on,
  off,
  once,
  mountLauncher,
  unmountLauncher,
  setUnreadCount,
  toggleWidget,
  getLauncherElement,
  openWidget,
  closeWidget,
  isWidgetOpen,
  getWidgetIframe,
  buildChatUrl,
  buildSessionUrl,
  sendToWidgetIframe,
  sendToOpenWindow,
  isBridgeActive,
  getAllowedOrigins,
  showEndBanner,
  hideEndBanner,
  sendProductCard,
  sendOrderCard,
  sendCouponCard,
  sendCard,
  DAJI_MSG_SOURCE,
  DAJI_MSG_VERSION,
  version,
};
export { HttpError, TimeoutError, fetchWithRetry, defaultShouldRetry } from './utils/fetch-with-retry';
export { EventEmitter } from './utils/event-emitter';
export type { DajiCSBootOptions, OpenOptions, ProductCard, WidgetCloseReason } from './types';
export type { DajiCSEventMap, DajiCSEventType, DajiCSListener } from './events';
export type { LauncherOptions, LauncherPosition, LauncherMode } from './launcher/launcher';
export type { WidgetState, WidgetPosition } from './launcher/widget';
export type { DajiMessage, DajiMsgType, EndPolicy } from './launcher/bridge';
export type { Listener, Unsubscribe } from './utils/event-emitter';
export type { SendCardOptions, SendCardResult, SendGenericCardPayload } from './send-card';
